"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POST_EVENT_ERROR_CODES = void 0;
/**
 * KATILIM BELGESİ VE ETKİNLİK SONRASI ANKET HATA KODLARI (Story 1). `ERROR_CODES`
 * sözlüğüne yayılır; değerler anahtarla aynıdır (ana sözlük dosya tavanında).
 */
exports.POST_EVENT_ERROR_CODES = {
    /**
     * Belge ve anket yalnız check-in yapmış, kaydı iptal edilmemiş katılımcıya ve
     * yalnız etkinlik bittikten sonra açılır (403). Neden ayrıştırılmaz.
     */
    POST_EVENT_NOT_ELIGIBLE: 'POST_EVENT_NOT_ELIGIBLE',
    /** Etkinliğin yayında anketi yok (taslak ve personelin kapattığı anket dahil, 404). */
    EVENT_SURVEY_NOT_FOUND: 'EVENT_SURVEY_NOT_FOUND',
    /** Etkinliğin zaten bir anketi var (409). */
    EVENT_SURVEY_EXISTS: 'EVENT_SURVEY_EXISTS',
    /** Anket kapandı: cevap kabul edilmez (409). */
    EVENT_SURVEY_CLOSED: 'EVENT_SURVEY_CLOSED',
    /** Kişi başına tek cevap: ikinci gönderim reddedilir (409). */
    EVENT_SURVEY_ALREADY_SUBMITTED: 'EVENT_SURVEY_ALREADY_SUBMITTED',
    /** Cevap anketin sorularıyla uyuşmuyor (bilinmeyen soru, tür, aralık; 400). */
    EVENT_SURVEY_ANSWER_INVALID: 'EVENT_SURVEY_ANSWER_INVALID',
    /** Anket bu durumda yayınlanamaz ya da kapatılamaz (409). */
    EVENT_SURVEY_STATE_CONFLICT: 'EVENT_SURVEY_STATE_CONFLICT',
    /** Yayın penceresi doldu: bitiş + 7 günden sonra yayın yok (409). */
    EVENT_SURVEY_PUBLISH_WINDOW_CLOSED: 'EVENT_SURVEY_PUBLISH_WINDOW_CLOSED',
    /** Anket en çok 10 soru taşır: 11. soru reddedilir (409, Story 3). */
    EVENT_SURVEY_QUESTION_LIMIT: 'EVENT_SURVEY_QUESTION_LIMIT',
    /** Soru bu anketin değil ya da sıralama listesi anketin sorularıyla uyuşmuyor (400). */
    EVENT_SURVEY_QUESTION_INVALID: 'EVENT_SURVEY_QUESTION_INVALID',
    /** Etkinliğin belgesi kapalı (404, katılımcı yüzeyinde giriş çizilmez). */
    EVENT_CERTIFICATE_DISABLED: 'EVENT_CERTIFICATE_DISABLED',
};
//# sourceMappingURL=error-codes-post-event.js.map